import React from 'react';
import moment from 'moment';
import { FormComponentProps } from 'antd/lib/form';
import { Form, Row, Col, DatePicker, InputNumber, Select, Input, Button } from 'antd';
import { withRouter } from 'kts-platform-frame/routes';
import MyStore from 'kts-platform-frame/redux/MyStore';
import Language from '../../../node_modules/kts-platform-frame/entry/Language';
import { TransformType } from '../../../node_modules/kts-platform-frame/entry/constant';
const FormItem = Form.Item;
const Option = Select.Option;
const css = require('./index.scss');
interface UserFormProps extends FormComponentProps {

}
interface IProps extends UserFormProps {
    fields: any;
    clearFields: () => void;
    onValuesChange?: (values: Array<any>) => void;
    onAddToGroup?: () => void;
    getData?: (type?:string,page?:number) => void;
    //history:any;
}
@withRouter
class Component extends React.Component<IProps, any> {
    private myform: any;
    /**
     * 高级搜索
     * @param {*} props 
     */
    private invoiceTypeOption = [
        { label: Language.transformTypeStringShort(TransformType.增值税专用发票), value: TransformType.增值税专用发票 },
        { label: Language.transformTypeStringShort(TransformType.增值税普通发票INVOICE), value: TransformType.增值税普通发票INVOICE },
        { label: Language.transformTypeStringShort(TransformType.机动车销售统一发票), value: TransformType.机动车销售统一发票 },
        { label: Language.transformTypeStringShort(TransformType.增值税电子普通发票), value: TransformType.增值税电子普通发票 },
        { label: Language.transformTypeStringShort(TransformType.增值税普通发票卷票), value: TransformType.增值税普通发票卷票 },
        { label: Language.transformTypeStringShort(TransformType.增值税电子专用发票), value: TransformType.增值税电子专用发票 },
        { label: Language.transformTypeStringShort(TransformType.通行费发票), value: TransformType.通行费发票 },
        { label: Language.transformTypeStringShort(TransformType.全电专票), value: TransformType.全电专票 },
        { label: Language.transformTypeStringShort(TransformType.全电普票), value: TransformType.全电普票 },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = {
            expand: false
        };
    }

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    }

    handleReset = () => {
        this.props.clearFields();
        this.props.form.resetFields();
    }
    onAddToGroup = () => {
        this.props.onAddToGroup();
    }
    toggle = () => {
        const { expand } = this.state;
        this.setState({ expand: !expand });
    }
    handleSearch = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.getData('',1);
                //this.props.history.push('invoiceInput');
            }

        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const userId = MyStore.instance.getState().user.userInfo.cUserId;
        const formItemLayout = {
            labelCol: { span: 7 },
            wrapperCol: { span: 17 },
        };
        return (
            <Form
                ref={(target) => { this.myform = target; }}
                onSubmit={this.handleSearch}
                className={css['invoice-filter']}
            >
                <Row>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`销方名称`}>
                            {getFieldDecorator("fuzzySupplierName")(
                                <Input type="text" />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`发票代码`}>
                            {getFieldDecorator("invoiceCode")(
                                <Input type="text" />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`发票号码`}>
                            {getFieldDecorator("invoiceNumber")(
                                <Input type="text" />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`录入用户`}>
                            <div id="userId">
                                {getFieldDecorator("userId")(
                                    <Select getPopupContainer={() => document.getElementById('userId')} allowClear={true}>
                                        <Option value="">全部用户</Option>
                                        <Option value={userId}>当前用户</Option>
                                    </Select>

                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem  {...formItemLayout} label={`发票类型`}>
                            <div id="invoiceType">
                                {getFieldDecorator("invoiceType")(
                                    <Select getPopupContainer={() => document.getElementById('invoiceType')} allowClear={true}>
                                        {this.invoiceTypeOption.map(d => <Option key={d.value}>{d.label}</Option>)}
                                    </Select>
                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`发票状态`}>
                            <div id="invoiceState">
                                {getFieldDecorator("invoiceState")(

                                    <Select getPopupContainer={() => document.getElementById('invoiceState')} allowClear={true}>
                                        <Option value="CANCELLED">作废</Option>
                                        <Option value="ABNORMAL">异常</Option>
                                        <Option value="UNCONTROLLED">失控</Option>
                                        <Option value="RED">红冲</Option>
                                        <Option value="NORMAL">正常</Option>
                                    </Select>

                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={8} className="hide">
                        <FormItem label="录入时间" {...formItemLayout}>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator("minLoggedDate")(
                                        <DatePicker
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span className="span-inline-style">-</span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator("maxLoggedDate")(
                                        <DatePicker
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`业务状态`}>
                            <div id="financeState">
                                {getFieldDecorator("financeState")(

                                    <Select getPopupContainer={() => document.getElementById('financeState')} allowClear={true}>
                                        <Option value="FAILED">已拒绝</Option>
                                        <Option value="PASS">已接受</Option>
                                    </Select>

                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={8} className="hide">
                        <FormItem {...formItemLayout} label={`合规状态`}>
                            <div id="standardState">
                                {getFieldDecorator("standardState")(

                                    <Select getPopupContainer={() => document.getElementById('standardState')} allowClear={true}>
                                        <Option value="FAILED">不合规</Option>
                                        <Option value="PASS">合规</Option>
                                    </Select>

                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`匹配状态`}>
                            <div id="matchState">
                                {getFieldDecorator("matchState")(
                                    <Select getPopupContainer={() => document.getElementById('matchState')} allowClear={true}>
                                        <Option value="UNMATCH">未匹配</Option>
                                        <Option value="MATCHED">已匹配</Option>
                                    </Select>
                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`认证状态`}>
                            <div id="authState">
                                {getFieldDecorator("authState")(
                                    <Select getPopupContainer={() => document.getElementById('authState')} allowClear={true}>
                                        <Option value="UNCHECK">未认证</Option>
                                        <Option value="FAILED">认证失败</Option>
                                        <Option value="PASS">已认证</Option>
                                    </Select>

                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem label="开票日期" {...formItemLayout}>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator("minInvoiceDate")(
                                        <DatePicker
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span className="span-inline-style">-</span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator("maxInvoiceDate")(
                                        <DatePicker
                                            style={{ width: "100%" }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem label="价税合计" {...formItemLayout}>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator("minAmount")(
                                        <InputNumber style={{ width: "100%" }} precision={2} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span className="span-inline-style">-</span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator("maxAmount")(
                                        <InputNumber style={{ width: "100%" }} precision={2} />
                                    )}
                                </FormItem>
                            </Col>
                        </FormItem>
                    </Col>
                    <Col span={8}>
                        <FormItem {...formItemLayout} label={`发票种类`}>
                            <div id="blueRedType">
                                {getFieldDecorator("blueRedType")(

                                    <Select getPopupContainer={() => document.getElementById('blueRedType')} allowClear={true}>
                                        <Option value="RED_INVOICE">红票</Option>
                                        <Option value="BLUE_INVOICE">蓝票</Option>
                                    </Select>

                                )}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span={24} className="text-right">
                        <Button className="mr10" onClick={this.handleReset}>
                            清空
                        </Button>
                        <Button type="primary" htmlType="submit">
                            筛选
                        </Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}
const WrappedAdvancedSearchForm = Form.create({
    mapPropsToFields(props: IProps) {
        return {
            fuzzySupplierName:
                Form.createFormField({ value: props.fields && props.fields.fuzzySupplierName })
            ,
            invoiceCode:
                Form.createFormField({ value: props.fields && props.fields.invoiceCode })
            ,
            invoiceNumber:
                Form.createFormField({ value: props.fields && props.fields.invoiceNumber })
            ,
            userId:
                Form.createFormField({ value: props.fields && props.fields.userId })
            ,
            invoiceType:
                Form.createFormField({ value: props.fields && props.fields.invoiceType })
            ,
            invoiceState:
                Form.createFormField({ value: props.fields && props.fields.invoiceState })
            ,
            minLoggedDate:
                Form.createFormField({ value: props.fields && (props.fields.minLoggedDate && moment(props.fields.minLoggedDate)) })
            ,
            maxLoggedDate:
                Form.createFormField({ value: props.fields && (props.fields.maxLoggedDate && moment(props.fields.maxLoggedDate)) })
            ,
            image:
                Form.createFormField({ value: props.fields && props.fields.image })
            ,
            financeState:
                Form.createFormField({ value: props.fields && (props.fields.financeState || null) })
            ,
            minInvoiceDate:
                Form.createFormField({ value: props.fields && (props.fields.minInvoiceDate && moment(props.fields.minInvoiceDate)) })
            ,
            maxInvoiceDate:
                Form.createFormField({ value: props.fields && (props.fields.maxInvoiceDate && moment(props.fields.maxInvoiceDate)) })
            ,
            minAmount:
                Form.createFormField({ value: props.fields && props.fields.minAmount })
            ,
            maxAmount:
                Form.createFormField({ value: props.fields && props.fields.maxAmount })
            ,
            standardState:
                Form.createFormField({ value: props.fields && props.fields.standardState })
            ,
            matchState:
                Form.createFormField({ value: props.fields && props.fields.matchState })
            ,
            authState:
                Form.createFormField({ value: props.fields && props.fields.authState })
            ,
            blueRedType:
                Form.createFormField({ value: props.fields && props.fields.blueRedType })
        };
    },
    onValuesChange(props: IProps, values: Array<any>) {
        props.onValuesChange(values);
    },
})(Component);
export default WrappedAdvancedSearchForm;



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceManage/AdvancedForm.tsx